/**
 * FlashToast — renders whatever's in the `flash` signal for ~5s, then
 * clears itself. Positioned bottom-right so it doesn't collide with the
 * top-of-shell banners (email-verify, billing).
 */

import { useEffect } from 'preact/hooks';
import { clearFlash, flash } from '../state/flash';

const DISPLAY_MS = 5_000;

export function FlashToast() {
  useEffect(() => {
    if (flash.value === null) return;
    const t = window.setTimeout(() => {
      clearFlash();
    }, DISPLAY_MS);
    return () => {
      window.clearTimeout(t);
    };
  }, [flash.value]);

  const f = flash.value;
  if (f === null) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      class="fixed bottom-4 right-4 z-20 max-w-sm rounded border border-emerald-300 bg-emerald-50 px-4 py-3 text-sm text-emerald-900 shadow-lg"
    >
      {f.message}
      <button
        type="button"
        aria-label="Dismiss"
        onClick={clearFlash}
        class="ml-3 text-emerald-700 hover:text-emerald-900"
      >
        ×
      </button>
    </div>
  );
}
